// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let Formality = require("../../vendor/re-formality/Formality.bs.js");
let Formality__ReactUpdate = require("../../vendor/re-formality/Formality__ReactUpdate.bs.js");

let validators_message = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: param => ({
    TAG: "Ok",
    _0: param.message
  })
};

let validators_subject = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: param => {
    let subject = param.subject.trim();
    if (subject === "") {
      return {
        TAG: "Error",
        _0: "is required"
      };
    } else {
      return {
        TAG: "Ok",
        _0: subject
      };
    }
  }
};

let validators_contacts = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: param => {
    let contacts = param.contacts;
    if (contacts.length !== 0) {
      return {
        TAG: "Ok",
        _0: contacts
      };
    } else {
      return {
        TAG: "Error",
        _0: "add at least one contact"
      };
    }
  }
};

let validators = {
  message: validators_message,
  subject: validators_subject,
  contacts: validators_contacts
};

function initialFieldsStatuses(input) {
  return {
    message: "Pristine",
    subject: "Pristine",
    contacts: "Pristine"
  };
}

function initialFieldStatuses_xxx(x) {
  return {
    message: "Pristine",
    subject: "Pristine",
    contacts: "Pristine"
  };
}

function initialState(input) {
  return {
    input: input,
    fieldsStatuses: {
      message: "Pristine",
      subject: "Pristine",
      contacts: "Pristine"
    },
    collectionsStatuses: undefined,
    formStatus: "Editing",
    submissionStatus: "NeverSubmitted"
  };
}

function validateForm(input, validators, fieldsStatuses) {
  let match = fieldsStatuses.message;
  let tmp;
  tmp = typeof match !== "object" ? validators.message.validate(input) : match._0;
  let match$1 = fieldsStatuses.subject;
  let tmp$1;
  tmp$1 = typeof match$1 !== "object" ? validators.subject.validate(input) : match$1._0;
  let match$2 = fieldsStatuses.contacts;
  let tmp$2;
  tmp$2 = typeof match$2 !== "object" ? validators.contacts.validate(input) : match$2._0;
  let messageResult = tmp;
  let messageResult$1;
  if (messageResult.TAG === "Ok") {
    let subjectResult = tmp$1;
    if (subjectResult.TAG === "Ok") {
      let contactsResult = tmp$2;
      if (contactsResult.TAG === "Ok") {
        return {
          TAG: "Valid",
          output: {
            contacts: contactsResult._0,
            subject: subjectResult._0,
            message: messageResult._0
          },
          fieldsStatuses: {
            message: {
              TAG: "Dirty",
              _0: messageResult,
              _1: "Shown"
            },
            subject: {
              TAG: "Dirty",
              _0: subjectResult,
              _1: "Shown"
            },
            contacts: {
              TAG: "Dirty",
              _0: contactsResult,
              _1: "Shown"
            }
          },
          collectionsStatuses: undefined
        };
      }
      messageResult$1 = messageResult;
    } else {
      messageResult$1 = messageResult;
    }
  } else {
    messageResult$1 = messageResult;
  }
  return {
    TAG: "Invalid",
    fieldsStatuses: {
      message: {
        TAG: "Dirty",
        _0: messageResult$1,
        _1: "Shown"
      },
      subject: {
        TAG: "Dirty",
        _0: tmp$1,
        _1: "Shown"
      },
      contacts: {
        TAG: "Dirty",
        _0: tmp$2,
        _1: "Shown"
      }
    },
    collectionsStatuses: undefined
  };
}

function useForm(initialInput, onSubmit) {
  let memoizedInitialState = React.useMemo(() => initialState(initialInput), [initialInput]);
  let match = Formality__ReactUpdate.useReducer(memoizedInitialState, (state, action) => {
    if (typeof action !== "object") {
      switch (action) {
        case "BlurMessageField" :
          let result = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.message, validators_message, status => {
            let init = state.fieldsStatuses;
            return {
              message: status,
              subject: init.subject,
              contacts: init.contacts
            };
          });
          if (result !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurSubjectField" :
          let result$1 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.subject, validators_subject, status => {
            let init = state.fieldsStatuses;
            return {
              message: init.message,
              subject: status,
              contacts: init.contacts
            };
          });
          if (result$1 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$1,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurContactsField" :
          let result$2 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.contacts, validators_contacts, status => {
            let init = state.fieldsStatuses;
            return {
              message: init.message,
              subject: init.subject,
              contacts: status
            };
          });
          if (result$2 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$2,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "Submit" :
          let match = state.formStatus;
          if (typeof match === "object" && match.TAG === "Submitting") {
            return "NoUpdate";
          }
          let match$1 = validateForm(state.input, validators, state.fieldsStatuses);
          if (match$1.TAG !== "Valid") {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: match$1.fieldsStatuses,
                collectionsStatuses: match$1.collectionsStatuses,
                formStatus: "Editing",
                submissionStatus: "AttemptedToSubmit"
              }
            };
          }
          let output = match$1.output;
          let error = state.formStatus;
          let tmp;
          tmp = typeof error !== "object" || error.TAG !== "SubmissionFailed" ? undefined : error._0;
          return {
            TAG: "UpdateWithSideEffects",
            _0: {
              input: state.input,
              fieldsStatuses: match$1.fieldsStatuses,
              collectionsStatuses: match$1.collectionsStatuses,
              formStatus: {
                TAG: "Submitting",
                _0: tmp
              },
              submissionStatus: "AttemptedToSubmit"
            },
            _1: param => {
              let dispatch = param.dispatch;
              onSubmit(output, {
                notifyOnSuccess: input => dispatch({
                  TAG: "SetSubmittedStatus",
                  _0: input
                }),
                notifyOnFailure: error => dispatch({
                  TAG: "SetSubmissionFailedStatus",
                  _0: error
                }),
                reset: () => dispatch("Reset"),
                dismissSubmissionResult: () => dispatch("DismissSubmissionResult")
              });
            }
          };
          break;
        case "DismissSubmissionError" :
          let match$2 = state.formStatus;
          if (typeof match$2 !== "object" || match$2.TAG !== "SubmissionFailed") {
            return "NoUpdate";
          } else {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: state.fieldsStatuses,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: "Editing",
                submissionStatus: state.submissionStatus
              }
            };
          }
        case "DismissSubmissionResult" :
          let match$3 = state.formStatus;
          if (typeof match$3 !== "object") {
            if (match$3 === "Editing") {
              return "NoUpdate";
            }
          } else if (match$3.TAG === "Submitting") {
            return "NoUpdate";
          }
          return {
            TAG: "Update",
            _0: {
              input: state.input,
              fieldsStatuses: state.fieldsStatuses,
              collectionsStatuses: state.collectionsStatuses,
              formStatus: "Editing",
              submissionStatus: state.submissionStatus
            }
          };
        case "Reset" :
          return {
            TAG: "Update",
            _0: initialState(initialInput)
          };
      }
    } else {
      switch (action.TAG) {
        case "UpdateMessageField" :
          let nextInput = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput,
              fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput, state.fieldsStatuses.message, state.submissionStatus, validators_message, status => {
                let init = state.fieldsStatuses;
                return {
                  message: status,
                  subject: init.subject,
                  contacts: init.contacts
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdateSubjectField" :
          let nextInput$1 = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput$1,
              fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$1, state.fieldsStatuses.subject, state.submissionStatus, validators_subject, status => {
                let init = state.fieldsStatuses;
                return {
                  message: init.message,
                  subject: status,
                  contacts: init.contacts
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdateContactsField" :
          let nextInput$2 = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput$2,
              fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$2, state.fieldsStatuses.contacts, state.submissionStatus, validators_contacts, status => {
                let init = state.fieldsStatuses;
                return {
                  message: init.message,
                  subject: init.subject,
                  contacts: status
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "SetSubmittedStatus" :
          let input = action._0;
          if (input !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: input,
                fieldsStatuses: {
                  message: "Pristine",
                  subject: "Pristine",
                  contacts: "Pristine"
                },
                collectionsStatuses: state.collectionsStatuses,
                formStatus: "Submitted",
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: {
                  message: "Pristine",
                  subject: "Pristine",
                  contacts: "Pristine"
                },
                collectionsStatuses: state.collectionsStatuses,
                formStatus: "Submitted",
                submissionStatus: state.submissionStatus
              }
            };
          }
        case "SetSubmissionFailedStatus" :
          return {
            TAG: "Update",
            _0: {
              input: state.input,
              fieldsStatuses: state.fieldsStatuses,
              collectionsStatuses: state.collectionsStatuses,
              formStatus: {
                TAG: "SubmissionFailed",
                _0: action._0
              },
              submissionStatus: state.submissionStatus
            }
          };
        case "MapSubmissionError" :
          let map = action._0;
          let error$1 = state.formStatus;
          if (typeof error$1 !== "object") {
            return "NoUpdate";
          }
          if (error$1.TAG !== "Submitting") {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: state.fieldsStatuses,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: {
                  TAG: "SubmissionFailed",
                  _0: map(error$1._0)
                },
                submissionStatus: state.submissionStatus
              }
            };
          }
          let error$2 = error$1._0;
          if (error$2 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: state.fieldsStatuses,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: {
                  TAG: "Submitting",
                  _0: map(error$2)
                },
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
      }
    }
  });
  let dispatch = match[1];
  let state = match[0];
  let match$1 = state.formStatus;
  let tmp;
  tmp = typeof match$1 !== "object" ? false : match$1.TAG === "Submitting";
  return {
    updateMessage: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateMessageField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updateSubject: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateSubjectField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updateContacts: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateContactsField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    blurMessage: () => dispatch("BlurMessageField"),
    blurSubject: () => dispatch("BlurSubjectField"),
    blurContacts: () => dispatch("BlurContactsField"),
    messageResult: Formality.exposeFieldResult(state.fieldsStatuses.message),
    subjectResult: Formality.exposeFieldResult(state.fieldsStatuses.subject),
    contactsResult: Formality.exposeFieldResult(state.fieldsStatuses.contacts),
    input: state.input,
    status: state.formStatus,
    dirty: () => {
      let match = state.fieldsStatuses;
      let tmp = match.message;
      if (typeof tmp === "object") {
        return true;
      }
      let tmp$1 = match.subject;
      if (typeof tmp$1 === "object") {
        return true;
      }
      let tmp$2 = match.contacts;
      return typeof tmp$2 === "object";
    },
    valid: () => {
      let match = validateForm(state.input, validators, state.fieldsStatuses);
      return match.TAG === "Valid";
    },
    submitting: tmp,
    submit: () => dispatch("Submit"),
    dismissSubmissionError: () => dispatch("DismissSubmissionError"),
    dismissSubmissionResult: () => dispatch("DismissSubmissionResult"),
    mapSubmissionError: map => dispatch({
      TAG: "MapSubmissionError",
      _0: map
    }),
    reset: () => dispatch("Reset")
  };
}

let initialCollectionsStatuses;

exports.validators = validators;
exports.initialFieldsStatuses = initialFieldsStatuses;
exports.initialFieldStatuses_xxx = initialFieldStatuses_xxx;
exports.initialCollectionsStatuses = initialCollectionsStatuses;
exports.initialState = initialState;
exports.validateForm = validateForm;
exports.useForm = useForm;
/* react Not a pure module */
